{
	"photoLoadingError": "Something went wrong while loading the photo. Please try again.",
	"photoMissingError": "This file is missing. Please make sure the file is in the directory and reload the project again.",
	"photoUnsupportedError": "This file is currently unsupported. Please contact {{email}} for assistance."
}
